import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'app-thumbs',
  templateUrl: './thumbs.component.html',
  styleUrls: ['./thumbs.component.scss']
})
export class ThumbsComponent implements OnInit {
  @Input()
  value: number;

  @Input()
  showGrey = false;

  @Output()
  incremented = new EventEmitter();

  get absValue() {
    return Math.abs(this.value);
  }

  get invertedAbsValue() {
    return this.items.length - this.absValue;
  }

  get sign() {
    return this.value > 0 ? 1 : -1;
  }

  get type() {
    return this.sign > 0 ? 'pro' : 'con';
  }

  get items() {
    return _.range(3);
  }

  ngOnInit() {}

  onClicked() {
    this.incremented.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/_shared/thumbs/thumbs.component.ts